import { classNames } from '@repo/ui/src/utils/classNames';
import React from 'react';
import AnimatedDigit from '@components/CountdownComponent/_AnimatedDigit';

interface TimeSegment {
  value: string;
  type?: string;
}

interface TimerBlockProps {
  darkMode: boolean;
  currentSegments: Array<TimeSegment>;
  prevSegments: Array<TimeSegment>;
  description?: string;
  className?: string;
  isAnimating: boolean;
  title?: string;
}

const TimerBlock = ({
  darkMode,
  currentSegments,
  prevSegments,
  description,
  className,
  isAnimating,
}: TimerBlockProps) => {
  return (
    <div
      data-testId="timer-block"
      className={classNames(
        'tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-transition-opacity tw-duration-1000 tw-ease-in-out tw-px-5',
        isAnimating ? 'tw-opacity-0' : 'tw-opacity-100',
        className,
      )}
    >
      <div className={classNames(darkMode ? 'tw-text-white' : 'tw-text-gray-800')}>
        <h2
          className={classNames(
            'tra-text-web-heading-1 tw-flex tw-items-center tw-justify-center tw-gap-1',
          )}
        >
          {currentSegments.map((segment, index) => (
            <React.Fragment key={index}>
              <div className="tw-inline-flex tw-items-center">
                {segment.value.split('').map((digit, i) => (
                  <AnimatedDigit
                    key={i}
                    value={digit}
                    prev={(prevSegments[index]?.value || segment.value)?.split('')[i] || digit}
                  />
                ))}
                {index < currentSegments.length - 1 && <span className="tw-mt-1 tw-mx-1">:</span>}
              </div>
            </React.Fragment>
          ))}
        </h2>
      </div>
      <hr
        className={classNames(
          'tw-border-2 tw-w-10 tw-border-brand-300 tw-my-4 tw-transition-opacity tw-ease-in-out',
        )}
      />
      {description && (
        <p
          className={classNames(
            'tra-text-web-body-xl tw-max-w-[700px]',
            darkMode ? 'tw-text-white' : 'tw-text-gray-800',
          )}
        >
          {description}
        </p>
      )}
    </div>
  );
};

export default TimerBlock;
